interface AppetiteRatingProps {
  value: number
  onChange: (value: number) => void
  disabled?: boolean
  hasError?: boolean
}

const APPETITE_LEVELS = [
  { value: 1, label: "Very Low", color: "bg-red-500", description: "Barely eating" },
  { value: 2, label: "Low", color: "bg-orange-500", description: "Below normal" },
  { value: 3, label: "Normal", color: "bg-yellow-500", description: "Average" },
  { value: 4, label: "Good", color: "bg-lime-500", description: "Above average" },
  { value: 5, label: "Excellent", color: "bg-emerald-500", description: "Very active" },
]

/**
 * Visual 1-5 rating selector for fish appetite.
 * Shows semantic labels and color-coded options.
 */
export function AppetiteRating({
  value,
  onChange,
  disabled = false,
  hasError = false,
}: AppetiteRatingProps) {
  return (
    <div className="space-y-2">
      <div className="flex gap-2">
        {APPETITE_LEVELS.map((level) => (
          <button
            key={level.value}
            type="button"
            onClick={() => !disabled && onChange(level.value)}
            disabled={disabled}
            className={`
              flex-1 py-3 px-2 rounded-lg border-2 transition-all text-center
              ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer hover:scale-105"}
              ${
                value === level.value
                  ? `${level.color} border-transparent text-white shadow-md`
                  : `bg-white border-slate-200/50 text-gray-700 hover:border-slate-300`
              }
              ${hasError && !value ? "border-red-300" : ""}
            `}
          >
            <div className="font-semibold text-lg">{level.value}</div>
            <div className={`text-xs ${value === level.value ? "text-white/90" : "text-gray-500"}`}>
              {level.label}
            </div>
          </button>
        ))}
      </div>
      {value > 0 && (
        <p className="text-sm text-gray-600 text-center">
          {APPETITE_LEVELS.find((l) => l.value === value)?.description}
        </p>
      )}
    </div>
  )
}
